import { render } from "./PersonCognitoIdentities.vue?vue&type=template&id=dee4d536&scoped=true"
import script from "./PersonCognitoIdentities.vue?vue&type=script&lang=js"
export * from "./PersonCognitoIdentities.vue?vue&type=script&lang=js"

import "./PersonCognitoIdentities.vue?vue&type=style&index=0&id=dee4d536&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee4d536"]])

export default __exports__